import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Assets from 'components/assets';
import { addGrowlError, addGrowlSuccess } from 'messages/actions';

import {
  setSelectedAsset,
  setEnableAssetModalIsOpened,
  sendTokenAsign,
} from 'containers/assets/actions';
import { getCompany, getSubcompany, getPermissions } from 'auth/selectors';
import { getLocations, getIsLoadingList } from 'selectors/lists';

class AssetsRowContainer extends Component {
  static propTypes = {
    asset: PropTypes.object.isRequired,
    locations: PropTypes.object.isRequired,
  };

  handleEnableAsset = (asset) => {
    this.props.setSelectedAsset(asset);
    this.props.setEnableAssetModalIsOpened(true);
  };
  handleSendTokenAsign = (asset) => {
    this.props
      .sendTokenAsign(asset._id, this.props.company.id, this.props.subcompany.id, asset)
      .then(({ value }) => {
        this.props.success(value.message);
      })
      .catch((err) => {
        this.props.error(err.message);
        this.finishSaving();
      });
  };
  render = () => {
    return (
      <Assets.Row
        asset={this.props.asset}
        isLoading={this.props.isLoading}
        handleEnableAsset={this.handleEnableAsset}
        handleSendTokenAsign={this.handleSendTokenAsign}
        locations={this.props.locations}
        companyId={this.props.company.id}
        permissions={this.props.permissions}
        subcompanyId={this.props.subcompany.id}
      />
    );
  };
}

const mapStateToProps = (state) => ({
  company: getCompany(state),
  locations: getLocations(state),
  permissions: getPermissions(state),
  subcompany: getSubcompany(state),
  isLoading: getIsLoadingList(state),
});

const mapDispatchToProps = {
  setSelectedAsset,
  setEnableAssetModalIsOpened,
  sendTokenAsign,
  success: addGrowlSuccess,
  error: addGrowlError,
};

export default connect(mapStateToProps, mapDispatchToProps)(AssetsRowContainer);



// WEBPACK FOOTER //
// src/containers/assets/AssetsRowContainer.js